import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=2675b5ca&scoped=true&"
import script from "./subMenu.vue?vue&type=script&lang=js&"
export * from "./subMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675b5ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2675b5ca')) {
      api.createRecord('2675b5ca', component.options)
    } else {
      api.reload('2675b5ca', component.options)
    }
    module.hot.accept("./subMenu.vue?vue&type=template&id=2675b5ca&scoped=true&", function () {
      api.rerender('2675b5ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/CargoDropdownMenu/subMenu.vue"
export default component.exports